import './Notification.scss';

// import { useTranslation } from 'react-i18next';
import { Warning } from '@phosphor-icons/react';
import {
  daysBetweenDates,
  formatIntlLongDateTime,
  relativeTimeBetweenDates,
} from '@whistler-ui/k2/helpers';
import React from 'react';

import { commonPageStylesIdentifier } from '../../constants';
import { notificationShape } from '../../shapes/notification';
import { useThemeStore } from '../../store/theme';
import { Netlync } from '../Icons';

const componentName = 'c-Notification';

/**
 * @component
 * A notification item for the notifications page.
 *
 * @param {ServiceNotification} notification - The notification.
 */
export const Notification = props => {
  const { colors } = useThemeStore();

  const {
    notification: { type, title, occurrence_time, content },
  } = props;

  /**
   * The occurrence time is a relative tme if the notification is less
   * than one week old, otherwise it's a date and time.
   */
  const occurrenceTime = (() => {
    return +daysBetweenDates(occurrence_time) > 7
      ? formatIntlLongDateTime(occurrence_time)
      : relativeTimeBetweenDates(occurrence_time);
  })();

  const badge =
    type === 'notification' ? (
      <Netlync
        className={`${componentName}__badge ${componentName}__badge--${type}`}
        size={32}
        color={colors.informative}
        weight="bold"
      />
    ) : (
      <Warning
        className={`${componentName}__badge ${componentName}__badge--${type}`}
        size={32}
        color={colors.colorFontPrimary}
        weight="bold"
      />
    );

  return (
    <div className={`${componentName} ${componentName}--${type}`}>
      {badge}
      <div className={`${componentName}__body`}>
        <div className={`${commonPageStylesIdentifier}__notification-title`}>
          {title}
        </div>
        <div
          className={`${commonPageStylesIdentifier}__notification-paragraph`}
        >
          {content}
        </div>
      </div>
      <div
        className={`${componentName}__date ${commonPageStylesIdentifier}__notification-title`}
      >
        {occurrenceTime}
      </div>
    </div>
  );
};

Notification.propTypes = { notification: notificationShape };
